import React from 'react';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetSeasonTopLists } from '../../../sportradar-widgets/SrWidgetSeasonTopLists';

function BetradarMTTopList({ matchId }) {
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper>
                <SrWidgetSeasonTopLists matchId={matchId} />
            </WidgetWrapper>
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTTopList;
